import { useState, useEffect } from 'react'
import { useActivity } from '../../Component/context_components/activities_context'
import Black_Arrow from '../../Assets/Icons/Black_Arrow.svg'
import ImageCarosel from '../../Component/Carosel/Image_Carosel'
import ExpandableText from '../../Component/HS/ExpandableText'
import moment from 'moment'
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardActions,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Container,
  CircularProgress,
  IconButton,
  useMediaQuery,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Activity = () => {
  const { activitiesData, yearsData } = useActivity()
  const [filter_date, setfilter_date] = useState('')
  const [Filter_Data, setFilter_data] = useState([])
  const [selectedImage, setSelectedImage] = useState(null)
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const isMobile = useMediaQuery('(max-width:600px)')

  useEffect(() => {
    if (Array.isArray(activitiesData)) {
      setFilter_data(activitiesData)
    } else {
      setFilter_data([])
    }
    setIsLoading(false)
  }, [activitiesData])

  const handleYearChange = (event, newValue) => {
    setfilter_date(newValue === 'All' ? '' : newValue)
    if (newValue === 'All' || !newValue) {
      setFilter_data(activitiesData)
    } else {
      setFilter_data(
        activitiesData.filter(
          (item) =>
            item?.date &&
            moment(item.date).year().toString() === newValue.toString()
        )
      )
    }
  }

  if (isLoading) {
    return (
      <Container sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    )
  }

  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      {/* Header & Filter */}
      <Box sx={{ px: { xs: 2, sm: 4 }, mb: 4 }}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12} md={8}>
            <Typography
              variant="h5"
              className="mb-4"
              sx={{
                color: 'text.primary',
                fontWeight: 'bold',
                mb: 2,
                position: 'relative',
                display: 'inline-block',
              }}
            >
              Events and Activities
              <Box
                sx={{
                  width: '50%',
                  height: 4,
                  backgroundColor: 'background.secondaryBackground',
                  position: 'absolute',
                  left: 0,
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Autocomplete
              options={['All', ...(Array.isArray(yearsData) ? yearsData : [])]}
              getOptionLabel={(option) => option.toString()}
              value={filter_date || 'All'}
              onChange={handleYearChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Year"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    style: { color: 'black' },
                  }}
                  InputLabelProps={{
                    style: { color: '#555' },
                  }}
                />
              )}
              sx={{
                minWidth: 150,
                '& .MuiInputBase-input': { color: 'black !important' },
              }}
              size="small"
            />
          </Grid>
        </Grid>
      </Box>

      {/* Cards */}
      <Box sx={{ px: { xs: 2, sm: 4 } }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress color="primary" />
          </Box>
        ) : Filter_Data && Filter_Data.length > 0 ? (
          <Grid container spacing={3}>
            {Filter_Data.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: 450, // fixed card height
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 2,
                    boxShadow: 2,
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardActionArea
                    sx={{
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    onClick={() => {
                      setSelectedImage(item)
                      setIsDialogOpen(true)
                    }}
                  >
                    {/* Fixed image area */}
                    <Box
                      sx={{ height: 200, width: '100%', overflow: 'hidden' }}
                    >
                      <ImageCarosel
                        image_data={item.activity_images}
                        sx={{
                          height: '100%',
                          width: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </Box>

                    {/* Card text */}
                    <CardContent sx={{ flexGrow: 1, width: '100%' }}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block', mb: 0.5 }}
                      >
                        {moment(item.event_date || item.date).format(
                          'MMMM D, YYYY'
                        )}
                      </Typography>
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                          fontWeight: 600,
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {item.heading}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          mt: 1,
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>

                  {/* Actions fixed at bottom */}
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button
                      onClick={() => {
                        setSelectedImage(item)
                        setIsDialogOpen(true)
                      }}
                      endIcon={<img src={Black_Arrow} alt="Arrow" width={16} />}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 500,
                        ml: 'auto',
                      }}
                    >
                      View Details
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              No activities found
            </Typography>
          </Box>
        )}
      </Box>

      {/* Dialog */}
      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            bgcolor: 'background.whiteBackground',
          },
        }}
      >
        {selectedImage && (
          <>
            <DialogTitle
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 2,
                pr: 2,
                pl: 3,
                borderBottom: 1,
                borderColor: 'divider',
              }}
            >
              <Typography
                variant="h5"
                color="text.primary"
                sx={{ fontWeight: 600 }}
              >
                {selectedImage.heading}
              </Typography>
              <IconButton onClick={() => setIsDialogOpen(false)} size="small">
                <CloseIcon color="text.primary" />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 3, py: 2 }}>
              <Box
                sx={{
                  position: 'relative',
                  fontSize: '1rem',
                  lineHeight: 1.8,
                  color: 'text.primary',
                }}
              >
                {/* Floated image */}
                <Box
                  sx={{
                    float: 'left',
                    width: { xs: '100%', sm: 300 },
                    mr: { xs: 0, sm: 3 },
                    mb: 2,
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: 2,
                  }}
                >
                  <ImageCarosel
                    image_data={
                      Array.isArray(selectedImage)
                        ? selectedImage
                        : [selectedImage]
                    }
                    imageStyle={{
                      width: '100%',
                      height: 'auto',
                      aspectRatio: '12/9',
                      objectFit: 'contain',
                    }}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 1, display: 'block' }}
                  >
                    <strong>Date:</strong>{' '}
                    {moment(
                      selectedImage.event_date || selectedImage.date
                    ).format('MMMM D, YYYY')}
                  </Typography>
                </Box>

                {/* Flowing text */}
                <Typography variant="body1" component="div">
                  <ExpandableText
                    fontSize={{ xs: '0.3rem', sm: '1rem' }}
                    text={selectedImage.description}
                    initialChars={400}
                    showFullText={false}
                  />
                </Typography>
              </Box>
            </DialogContent>

            <DialogActions
              sx={{
                px: 1,
                py: 1,
                borderTop: 1,
                borderColor: 'divider',
              }}
            >
              <Button
                onClick={() => setIsDialogOpen(false)}
                variant="contained"
                color="primary"
                sx={{ borderRadius: 2, p: 1, m: 1 }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Container>
  )
}

export default Activity
